import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import { dummyData } from '../../../src/pages/Numbers/Manage/dummyData'

export const NUMBERS_SUPPORTED_COUNTRIES_LOADING = "NUMBERS_SUPPORTED_COUNTRIES_LOADING";
export const NUMBERS_SUPPORTED_COUNTRIES_SUCCESS = "NUMBERS_SUPPORTED_COUNTRIES_SUCCESS";
export const NUMBERS_SUPPORTED_COUNTRIES_FAILED = "NUMBERS_SUPPORTED_COUNTRIES_FAILED";


export const getNumberSupportedCountriesData = () => {


    return (dispatch: Dispatch<any>) => {
        dispatch({ type: NUMBERS_SUPPORTED_COUNTRIES_LOADING });
        setTimeout(() => {
            dispatch({ type: NUMBERS_SUPPORTED_COUNTRIES_SUCCESS, payload: { res: dummyData.supportedCountriesData } })
        }, 2000);

        // networkCall("get", `/numbers_supported_countries, apiBaseUrl.baseUrl)
        //     .then((res: any) => {
        //         if (res.data && res.data.length) {
        //             dispatch({ type: NUMBERS_SUPPORTED_COUNTRIES_SUCCESS, payload: { res: res } });
        //         } else {
        //             dispatch({ type: NUMBERS_SUPPORTED_COUNTRIES_FAILED, payload: { error: res.error.error } });
        //         }
        //     }).catch((error) => {
        //         if (error?.response?.data) {
        //             dispatch({ type: NUMBERS_SUPPORTED_COUNTRIES_FAILED, payload: { error } });
        //         }
        //     });
    }
}
